<div class="update__additional__cost__cargo col-md-12">
  <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close({ state: true })"></i>
  <div class="additional-service-container">
    <div class="additional-service-loading" *ngIf="loadingAdditionalServices">
      <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '48px', 'margin-bottom': '20px' }">
      </ngx-skeleton-loader>
      <ngx-skeleton-loader count="2" appearance="line" [theme]="{ height: '160px', 'margin-bottom': '14px' }">
      </ngx-skeleton-loader>
    </div>
    <app-additional-service class="additional-service-component" *ngIf="!loadingAdditionalServices"
      (additionalCostSelected)="additionalCostSelected($event)" (emitToParent)="emitToParent($event)" [cargo]="cargo"
      [listAdditionalService]="listAdditionalService" [modelForm]="modelFormAdditionalCost" [readonly]="true"
      [companyId]="cargo.idCompany" [cargoId]="cargo.id" [approvalState]="cargo.approval"
      [listActive]="paramsDialog.listActive">
    </app-additional-service>
    <!-- Button -->
    <div class="col-md-12" *ngIf="!loadingAdditionalServices && showBtnCreateAdditionalService.show && isAdditionalService">
      <div class="d-flex flex-row align-items-center justify-content-center pb-4">
        <button mat-raised-button class="button-width-auto" color="primary" (click)="save()"
          [disabled]="!showBtnCreateAdditionalService.canCreate"
          [matTooltip]="showBtnCreateAdditionalService.errorMessage" matTooltipPosition="above"
          matTooltipClass="tooltip__error">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>